<script setup lang="ts">
import { useI18n } from '@/plugins/i18n';
import FilterDropdown from '@/components/Search/FilterDropdown.ce.vue';
import iconMyCollections from '@/assets/img/icon-search-all-filters-my-collections.svg';
import iconCompanyCollection from '@/assets/img/icon-search-all-filters-company-collection.svg';
import iconDocumentType from '@/assets/img/icon-search-all-filters-document-type.svg';
import iconStatus from '@/assets/img/icon-search-all-filters-status.svg';
import iconTags from '@/assets/img/icon-search-all-filters-tags.svg';
import type { SearchFilterOption } from '@/components/Search/types.ts';
import { useSearchStore } from '@/components/Search/store/index.ts'
import { COLLECTIONS_SEARCH_TAB, STANDARDS_SEARCH_TAB } from '@/components/Search/constants.ts';
import CategoriesFilter from '@/components/Search/SearchFilters/Common/CategoriesFilter/index.ce.vue';

const props = defineProps({
    searchOnSelect: { type: Boolean, default: true },
    forMobile: { type: Boolean, default: false }
})

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//store
const searchStore = useSearchStore()
const updateSelectedItems = (items: SearchFilterOption[]) => {
  if(props.searchOnSelect) {
    searchStore.searchCollections(true);
  }
}
</script>

<template>
    <div class="collections-filters">
        <div class="filter-item myCollections">
          <FilterDropdown
            className="accordion"
            :placeholder="t('myCollections')" 
            name="colls[]" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.facetFilter.collections`"
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.facetFilter.collections`"
            :defaultOptionLookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.collections`"
            :hasClear="false" 
            :iconMain="iconMyCollections"
            :iconOpenMain="iconMyCollections"
            :searchable="true" 
            :loadOptionsOnClick="true"
            @updateSelectedItems="updateSelectedItems"/>
        </div>
        <div class="filter-item companyCollection">
          <FilterDropdown
            className="accordion"
            :placeholder="t('companySets')" 
            name="dcoll" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.facetFilter.companyCollection`"
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.facetFilter.companyCollection`"
            :defaultOptionLookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.companyCollection`"
            :hasClear="false" 
            :iconMain="iconCompanyCollection"
            :iconOpenMain="iconCompanyCollection"
            :searchable="true" 
            :loadOptionsOnClick="true"
            @updateSelectedItems="updateSelectedItems"/>
        </div>
        <div class="filter-item documentType">
          <FilterDropdown 
            className="accordion"
            :placeholder="t('documentType')" 
            name="type" 
            :multiple="false" 
            :field="`${COLLECTIONS_SEARCH_TAB}.facetFilter.documentType`"
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.facetFilter.documentType`"
            :defaultOptionLookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.documentType`"
            :searchable="false"
            :hasClear="false"
            :iconMain="iconDocumentType"
            :iconOpenMain="iconDocumentType"
            @updateSelectedItems="updateSelectedItems"
            />
        </div>  
        <div class="filter-item status">
          <FilterDropdown
            className="accordion"
            :placeholder="t('status')" 
            name="status" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.facetFilter.status`" 
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.facetFilter.status`" 
            :defaultOptionLookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.status`"
            :hasClear="false" 
            :iconMain="iconStatus"
            :iconOpenMain="iconStatus"
            :searchable="false"
            @updateSelectedItems="updateSelectedItems"/>
        </div>
        <div class="filter-item tag">
          <FilterDropdown
            className="accordion"
            :placeholder="t('tag')" 
            name="tag" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.facetFilter.tags`" 
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.facetFilter.tags`" 
            :defaultOptionLookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.tags`"
            :hasClear="false" 
            :iconMain="iconTags"
            :iconOpenMain="iconTags"
            :searchable="false"
            :loadOptionsOnClick="true"
            @updateSelectedItems="updateSelectedItems"/>
        </div>
        <div class="filter-item categories">
          <CategoriesFilter :searchType="COLLECTIONS_SEARCH_TAB" className="accordion" 
          :facetFilter="true"
          :useTeleport="!forMobile"></CategoriesFilter>
        </div>
        <div class="filter-item notes">
          <input type="text" name="notes" :placeholder="t('searchViaNotes')" v-model="searchStore[`${COLLECTIONS_SEARCH_TAB}.facetFilter.notes`]" autocomplete="off"  @keyup.enter="searchStore.searchCollections(true)"/>
        </div>
    </div>
</template>